module.exports = __webpack_public_path__ + "media/bird_1.8948ecb1.mp3";